/**
 * Constantes para página pública
 */

export const API_BASE =
  (typeof process !== "undefined" && process.env?.NEXT_PUBLIC_API_BASE_URL) ||
  "http://localhost:3333";

/**
 * Número de dias no futuro para mostrar disponibilidade
 */
export const AVAILABILITY_DAYS_AHEAD = 30;

/**
 * Mapa de ícones de redes sociais
 */
export const SOCIAL_ICONS = {
  instagram: "SiInstagram",
  tiktok: "SiTiktok",
  youtube: "SiYoutube",
  whatsapp: "SiWhatsapp",
} as const;

/**
 * Mapa de ícones de localização
 */
export const LOCATION_ICONS = {
  maps: "SiGooglemaps",
  waze: "SiWaze",
  pin: "FiMapPin",
  external: "FiExternalLink",
} as const;
